export default __webpack_public_path__ + "static/media/image-about-mission-w@3x.f1ec8162.png";